import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React, { useEffect } from "react";
import { Redirect, Switch, Route, Link, withRouter } from "react-router-dom";
import { traffic } from "./config/traffic"; // Initial setup

import config from "./config"; // Components

import PropertyAppProvider from "./AppProvider"; // Routes

import { Routes as SearchRoutes } from "./pages/explore/search";
import { Routes as ApartmentsRoutes } from "./pages/explore/apartments";
import { Routes as LandForSaleRoutes } from "./pages/explore/land-for-sale";
import { Routes as TownhomesRoutes } from "./pages/explore/townhomes";
import { Routes as PackageRoutes } from "./pages/explore/package";
import PageNotFound from "./pages/errors/404"; // styles

import "./App.scss";
export * from "./AppProvider";
var isLoadedFromAnotherHost = traffic.get("app.url"),
    ScrollToTop = withRouter(function (a) {
  var b = a.children,
      c = a.location,
      d = c.pathname,
      e = c.search;
  return useEffect(function () {
    -1 === window.location.pathname.indexOf(config.routes.apartments) && window.scrollTo(0, 0);
  }, [d, e]), b || null;
}),
    isDevelopmentCompany = !config.api.get("project") && !config.api.get("neighbourhood");
export var PropertyApp = function PropertyApp() {
  var a = [].concat(_toConsumableArray(SearchRoutes), _toConsumableArray(PackageRoutes), _toConsumableArray(LandForSaleRoutes));
  return !1, isDevelopmentCompany || (a = [].concat(_toConsumableArray(a), _toConsumableArray(ApartmentsRoutes), _toConsumableArray(TownhomesRoutes))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollToTop, null), isLoadedFromAnotherHost || 1 ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: config.routes.get("property.search")
  }, "Property search"), config.acf_settings.masterplan ? /*#__PURE__*/React.createElement(React.Fragment, null, " | ", /*#__PURE__*/React.createElement("a", {
    href: "/masterplan.html"
  }, "Masterplan")) : null, config.acf_settings.amenities ? /*#__PURE__*/React.createElement(React.Fragment, null, " | ", /*#__PURE__*/React.createElement("a", {
    href: "/amenities.html"
  }, "Amenities")) : null, isDevelopmentCompany ? null : /*#__PURE__*/React.createElement(React.Fragment, null, " | ", /*#__PURE__*/React.createElement(Link, {
    to: config.routes.get("apartments")
  }, "Apartments"), " | ", /*#__PURE__*/React.createElement(Link, {
    to: config.routes.get("landforsale.masterplan")
  }, "Land for Sale"), " | ", /*#__PURE__*/React.createElement(Link, {
    to: config.routes.get("townhomes")
  }, "Townhomes"))), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement(Switch, null, a.map(function (a, b) {
    var c = a.name,
        d = _objectWithoutProperties(a, ["name"]);

    return /*#__PURE__*/React.createElement(Route, Object.assign({
      key: b
    }, d));
  }), /*#__PURE__*/React.createElement(PageNotFound, null)));
};
export var App = function App() {
  return /*#__PURE__*/React.createElement(PropertyAppProvider, null, /*#__PURE__*/React.createElement(PropertyApp, null));
};
export default PropertyApp;